import { alpha, lighten } from '@mui/material';

const DARK_FILL_ALPHA = 0.2;
const DARK_HOVER_ALPHA = 0.3;
const DARK_OUTLINED_HOVER_ALPHA = 0.18;
const DARK_BORDER_ALPHA = 0.5;
const DARK_TEXT_LIGHTEN = 0.4;

// The SYSTEM_COLORS bg is a pale light tint and fg is a saturated dark hue; both leak/dim on the dark
// canvas. In dark mode build the recipe from fg: a low-alpha tint fill + a lightened readable text.
const getDarkText = fg => lighten(fg, DARK_TEXT_LIGHTEN);

export const getColorStyles = ({ resolvedColor, variant }) => {
  if (!resolvedColor) {
    return {};
  }

  const { bg, fg, soft } = resolvedColor;

  if (variant === 'contained') {
    return {
      backgroundColor: ({ palette }) => (palette.mode === 'dark' ? alpha(fg, DARK_FILL_ALPHA) : bg),
      color: ({ palette }) => (palette.mode === 'dark' ? getDarkText(fg) : fg),
      borderColor: ({ palette }) => (palette.mode === 'dark' ? alpha(fg, DARK_BORDER_ALPHA) : fg),
      '&:hover': {
        backgroundColor: ({ palette }) =>
          palette.mode === 'dark' ? alpha(fg, DARK_HOVER_ALPHA) : soft,
        borderColor: ({ palette }) => (palette.mode === 'dark' ? alpha(fg, DARK_BORDER_ALPHA) : fg),
      },
    };
  }

  return {
    borderColor: ({ palette }) => (palette.mode === 'dark' ? alpha(fg, DARK_BORDER_ALPHA) : fg),
    color: ({ palette }) => (palette.mode === 'dark' ? getDarkText(fg) : fg),
    '&:hover': {
      borderColor: ({ palette }) => (palette.mode === 'dark' ? alpha(fg, DARK_BORDER_ALPHA) : fg),
      backgroundColor: ({ palette }) =>
        palette.mode === 'dark' ? alpha(fg, DARK_OUTLINED_HOVER_ALPHA) : soft,
    },
  };
};
